import React, { useState } from "react";
import "./Like_heart_btn_holder.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";

function LikeHeartBtnHolder() {
  const [liked, setLiked] = useState(false);

  return (
    <section 
      className="Like_heart_btn_holder" 
      onClick={() => setLiked(!liked)}
    >
      <FontAwesomeIcon 
        icon={faHeart} 
        className={liked ? "heart liked" : "heart"} 
      />
    </section>
  );
}

export default LikeHeartBtnHolder;
